import React, {useEffect, useRef, useState} from "react"
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as GroupGameService from "../../api/GroupGameService"
import {useParams, useSearchParams} from "react-router-dom";
import GroupGameViewStyle from "./GroupGameView.module.css"
import useWebSocket from "react-use-websocket";
import GroupGameViewMentorPlayerSelector from "./GroupGameViewMentorPlayerSelector";
import {defaultData} from "../../pages/table/Data";
import GroupGameTable from "./GroupGameTable";
import Draggable from "react-draggable";
import DiceComponent from "./DiceComponent";

import * as Helpers from "./AHelpers"
import SideBar from "./SideBar";
import ReorderOutlinedIcon from "@mui/icons-material/ReorderOutlined";
import SideBarOffCanvas from "./SideBarOffCanvas";
import MetaphoricCardsModal from "./MetaphoricCardsModal";
import PayGame from "../PayGame";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import ChangeVideoModal from "../../pages/table/ChangeVideoModal";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import DialogComponent from "../DialogComponent";
import {useTranslation} from "react-i18next";
import TranslationSwitch from "../../translation/translationSwitch";
import * as GameService from "../../api/GameService";
import GameFieldOffCanvasTimer from "../GameFieldOffCanvasTimer";
import SelectedMetaphoricCardsModal from "./HistoryMetaphoricCardsModal";
import {wsBaseUrl} from "../../api/ApiUtils";

export default function GroupGameViewMentor() {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'gameField'});
    const [myCards, setMyCards] = useState()
    const [gameSuccessfullyFetched, setGameSuccessfullyFetched] = useState(undefined)
    const [gameFieldStyle, setGameFieldStyle] = useState(undefined)
    const [gameState, setGameState] = useState()
    const [onVideoCall, setOnVideoCall] = useState(false)
    const [selectedPlayerId, setSelectedPlayerId] = useState()
    const [selectedPlayer, setSelectedPlayer] = useState()
    const [playersPositions, setPlayersPositionss] = useState()
    const [selectedPlayerChange, setSelectedPlayerChange] = useState(false)

    const [isDiceHorizontal, setDiceHorizontal] = useState(true)
    const [showCanvas, setShowCanvas] = useState(false)

    const [showMetaphoricCardsModal, setShowMetaphoricCardsModal] = useState(false)
    const [selectedMetaphoricCardStackData, setSelectedMetaphoricCardStackData] = useState()

    const [showSharedMetaphoricCard, setShowSharedMetaphoricCard] = useState(false)
    const [sharedMetaphoricCardData, setSharedMetaphoricCardData] = useState({})

    const [showChangeVideoModal, setShowChangeVideoModal] = useState(false)

    const gameLastUpdate = useRef()

    const params = useParams()
    const [queryParams] = useSearchParams()

    const {
        lastJsonMessage,
        readyState
    } = useWebSocket(wsBaseUrl + `ws/game/${params.id}/stream`, {
        shouldReconnect: () => true,
        share: true
    });

    useEffect(
        () => {
            console.log(readyState)
        }, [readyState]
    )

    function closeMetaphoricCardModal() {
        setShowMetaphoricCardsModal(false)
    }

    useEffect(() => {

        if (lastJsonMessage?.message === "new user move") {
            callGameState()
        }

        if (lastJsonMessage?.message?.type === "game_redirect" && lastJsonMessage?.message?.game_id !== undefined) {
            if (gameState.role === "mentor") {
                if (onVideoCall) {
                    window.open(`/groupgame/${lastJsonMessage.message.game_id}?autovideo=on`, "_self")
                } else {
                    window.open(`/groupgame/${lastJsonMessage.message.game_id}`, "_self")
                }

            } else {
                const newPlayerId = lastJsonMessage.message.players[selectedPlayerId]
                if (onVideoCall) {
                    window.open(`/groupgame/${lastJsonMessage.message.game_id}?player=${newPlayerId}&autovideo=on`, "_self")
                } else {
                    window.open(`/groupgame/${lastJsonMessage.message.game_id}?player=${newPlayerId}`, "_self")
                }

            }
        }

        if (lastJsonMessage?.message?.name === "cards" && lastJsonMessage?.message?.player_id === queryParams.get("player")) {
            setShowMetaphoricCardsModal(true)
            setSelectedMetaphoricCardStackData(lastJsonMessage?.message?.stack_data)
        }

        if (lastJsonMessage?.message?.name === "share_card" && lastJsonMessage?.message?.shared_by !== queryParams.get("player")) {
            setShowSharedMetaphoricCard(true)
            setSharedMetaphoricCardData({
                cardLink: lastJsonMessage?.message?.card_link,
                deckId: lastJsonMessage?.message?.deck_id,
            })
        }

    }, [lastJsonMessage]);

    const defaultStyle = {
        "background_img_url": "https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/game_field.png",
        "background_colors": "#263076, #0c0a10, #0c0a10, #0c0a10"
    }

    function updateVideoType() {
        GroupGameService.changeVideoType(
            gameState.id,
            () => {
                setShowChangeVideoModal(false)
            },
            () => {
                window.alert(t('errorOnVideoTypeChange'))
            }
        )

    }

    function pullCards() {
        GroupGameService.getAllMentorCardsByGroupGameId(params.id, setMyCards, () => setGameSuccessfullyFetched(false))
    }

    function handleSelectedPlayer(selectedPlayer) {
        if (gameState?.role === "player") {
            return
        }
        setSelectedPlayerId(selectedPlayer)
        setSelectedPlayerChange(true)
    }

    function callGameStyle() {
        GroupGameService.getCurrentGroupGameStyle(params.id,
            (style) => setGameFieldStyle(style),
            () => {
                console.error("failed to fetch game style, setting default")
                setGameFieldStyle(defaultStyle)
            }
        )
    }

    function callGameState() {
        GroupGameService.getGroupGame(params.id, queryParams.get("player"), (state) => {
            setGameState(state)
            gameLastUpdate.current = state?.modified
            setGameSuccessfullyFetched(true)
            if (state.role === "mentor") {
                const lasPlayerActedId = state.last_player_acted
                const lastPlayerActed = state.players.filter(p => p.id === lasPlayerActedId)[0]
                if (lastPlayerActed?.last_action === "move") {
                    setSelectedPlayerId(lasPlayerActedId)
                }
            }
        }, (response) => {
            if (response.status === 404) {
                setGameSuccessfullyFetched(false)
            } else {
                window.alert(t('couldNotGetGameError'))
                setGameSuccessfullyFetched(false)
            }

        })
    }

    useEffect(() => {
        // Handle Users positions

        if (gameState) {
            setSelectedPlayerChange(false)
            if (gameState.role === "player") {
                setSelectedPlayerId(queryParams.get("player"))
            } else if (!selectedPlayer) {
                setSelectedPlayerId(gameState.players[0].id)
            }


            let finitUsersPositions = {}
            for (const player of gameState?.players) {
                finitUsersPositions[player.id] = player.current_user_position
            }

            if (gameState.last_player_acted) {
                const lastPlayerActed = Helpers.getGroupGameLastActedPlayer(gameState, gameState.last_player_acted)
                if (lastPlayerActed?.last_action === "move" && lastPlayerActed?.last_step_moves === 2) {
                    let intermediatePositions = {...finitUsersPositions}
                    intermediatePositions[lastPlayerActed.id] = lastPlayerActed.steps[0].from_position

                    setPlayersPositionss(intermediatePositions)
                    trySetTimeout(() => {
                        setPlayersPositionss(finitUsersPositions)
                    }, 2500)

                } else {
                    // last player made 1 move
                    setPlayersPositionss(finitUsersPositions)
                }
            } else {
                // everyone is on the starting position
                setPlayersPositionss(finitUsersPositions)
            }

        }


    }, [gameState])

    useEffect(() => {
        if (selectedPlayerId && gameState) {
            for (const player of gameState.players) {
                if (player.id === selectedPlayerId) {
                    setSelectedPlayer(player)
                }
            }
        }
    }, [selectedPlayerId, gameState])

    useEffect(() => {
        callGameState()
    }, [params.id])

    useEffectOnce(() => {
        pullCards()
        callGameStyle()
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            GroupGameService.getCurrentGameCached(params.id, queryParams.get("player"), (state) => {
                if (gameLastUpdate.current !== state.modified)
                {
                    setGameState(state)
                    gameLastUpdate.current = state.modified
                }
            }, (error)=>{
                console.error("Cached group game call error", error)
            })
        }, 10000)
        return () => {
            clearInterval(intervalId)
        }
    }, [])

    function GameFieldStyle() {
        return Object.assign(
            {
                display: "grid",
                gridTemplateColumns: "5fr 3fr",
                paddingLeft: "5px",
                paddingRight: "25px",
                paddingTop: "0px",
                paddingBottom: "0px",
                height: "100%",
                backgroundImage: "linear-gradient(to right," + gameFieldStyle.background_colors + ")"
            }
        )
    }

    function GameFieldStyleImage() {
        return Object.assign(
            {
                width: gameFieldStyle.background_img_width,
                height: gameFieldStyle.background_img_height,
                paddingTop: gameFieldStyle.padding_top,
                paddingLeft: gameFieldStyle.padding_left,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundImage: "url(" + gameFieldStyle.background_img_url + ")"
            }
        )
    }

    const nodeRef = useRef()

    return (
        <>
            {gameSuccessfullyFetched && gameFieldStyle && gameState && selectedPlayer &&
                <div className={GroupGameViewStyle.container}>
                    <div style={new GameFieldStyle()} id={"boundaries"}>
                        <div className={GroupGameViewStyle.mainViewContainerMentor}>
                            <GroupGameViewMentorPlayerSelector players={gameState.players}
                                                               selectedPlayer={selectedPlayerId}
                                                               setSelectedPlayer={handleSelectedPlayer}/>
                            {gameState.require_payment && <PayGame
                                gameId={gameState.id}
                                createdInFreeTier={gameState.created_in_free_tier}
                                isMentor={gameState.role === "mentor"}
                            />}
                            <div style={new GameFieldStyleImage()}>
                                {gameState?.aob_player &&
                                    <div
                                        className={GroupGameViewStyle.aobWarning}> {t('playerLinkOpened')} {gameState.aob_player}</div>}
                                <GroupGameTable
                                    cellsData={defaultData}
                                    cards={myCards || {}}
                                    gameState={gameState}
                                    selectedPlayer={selectedPlayerId}
                                    playersPositions={playersPositions}
                                    selectedPlayerChange={selectedPlayerChange}
                                    setSelectedPlayer={handleSelectedPlayer}
                                    fieldStyle={gameFieldStyle}
                                />
                            </div>
                        </div>
                        <div className={GroupGameViewStyle.sideBarWithCanvas}>
                            <div className={GroupGameViewStyle.sideBar}>
                                {selectedPlayer
                                    && !selectedPlayer.is_over
                                    && !gameState.require_payment
                                    && <Draggable
                                        nodeRef={nodeRef}
                                        axis="both"
                                        handle=".handle"
                                        defaultPosition={{x: 0, y: 350}}
                                        scale={1}
                                        bounds="#boundaries"
                                    >
                                        <div ref={nodeRef} style={{
                                            position: "absolute",
                                            zIndex: 1500,
                                            width: selectedPlayer?.is_auto_dice ? 140 : isDiceHorizontal ? 400 : 145
                                        }}>
                                            <DiceComponent
                                                game_id={gameState.id}
                                                selectedPlayer={selectedPlayer}
                                                isDiceHorizontal={isDiceHorizontal}
                                                setDiceHorizontal={setDiceHorizontal}
                                            />
                                        </div>

                                    </Draggable>}
                                <SideBar gameRole={gameState?.role}
                                         gameState={gameState}
                                         selectedPlayer={selectedPlayer}
                                         cards={myCards || ""}
                                         updateGameState={callGameState}
                                         setOnVideoCall={setOnVideoCall}
                                />
                            </div>
                            <div>
                                <div style={{marginTop: "10px", marginRight: "6px", color: "white"}}>
                                    <TranslationSwitch></TranslationSwitch>
                                </div>
                                {gameState.role === "mentor" &&
                                    <div>
                                        <ReorderOutlinedIcon
                                            style={{
                                                marginTop: "12px",
                                                color: "white"
                                            }}
                                            onClick={() => setShowCanvas(true)}/>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{show: 400, hide: 50}}
                                            overlay={<Tooltip
                                                id="button-tooltip">{t('problemsWithVideoPush')}</Tooltip>}
                                        >
                                            <ErrorOutlineOutlinedIcon fontSize={"medium"}
                                                                      style={{marginTop: "12px", color: "red"}}
                                                                      onClick={() => setShowChangeVideoModal(true)}></ErrorOutlineOutlinedIcon>
                                        </OverlayTrigger>
                                        {showCanvas && <SideBarOffCanvas
                                            show={showCanvas}
                                            onClose={setShowCanvas}
                                            gameId={gameState.id}
                                            selectedPlayerId={selectedPlayerId}
                                            cards={myCards || {}}
                                            gameState={gameState}
                                        />}
                                    </div>
                                }
                            </div>

                        </div>
                    </div>

                </div>
            }
            {
                showMetaphoricCardsModal && queryParams.get("player") && <MetaphoricCardsModal
                    selectedStackData={selectedMetaphoricCardStackData}
                    modalOpened={showMetaphoricCardsModal}
                    closeModal={closeMetaphoricCardModal}
                    gameId={gameState.id}
                    playerId={queryParams.get("player")}
                />
            }
            {
                showChangeVideoModal && <ChangeVideoModal changeVideo={updateVideoType}
                                                          closeModal={() => setShowChangeVideoModal(false)}></ChangeVideoModal>
            }
            {readyState === 3 && <DialogComponent
                title={t('noConnectionServerLost')}
                hideCancelButton={true}
                onConfirm={() => window.location.reload()}
                agreeButtonText={t('reloadThePage')}

            />}

            {gameState?.role === "mentor" && <GameFieldOffCanvasTimer game_id={gameState.id}/>}
            {showSharedMetaphoricCard && <SelectedMetaphoricCardsModal
                cardLink={sharedMetaphoricCardData.cardLink}
                deckId={sharedMetaphoricCardData.deckId}
                closeModal={()=> {setShowSharedMetaphoricCard(false)}}
                allowShare={false}
            />}
        </>
    )
}